import React, { useEffect } from 'react';

import './menu.scss';

export interface MenuProps {
  x?: number;
  y?: number;
  right?: number;
}

export const MenuComponent: React.FC<MenuProps> = ({ x, y, right, children }) => {
  const myStyle: any = {
    top: `${y}px`,
  };

  if (x !== undefined)
    myStyle.left = `${x}px`;
  else if (right !== undefined)
    myStyle.right = `${right}px`;

  return (
    <div style={myStyle} className="menu__right">
      {children}
    </div>
  );
};
